import DocumentApi from "../api/DocumentApi";

export const getDocuments = (material : string) => {
    return DocumentApi.getDocuments(material);
}